// Unpublished Work © 2021-2022 Deere & Company

import t from 'tcomb';

export const CustomerIds = t.struct({
    contactId: t.Number,
    entityId: t.Number
}, {
    name: 'CustomerIds',
    defaultProps: {
        contactId: 0,
        entityId: 0
    }
});
